/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WorkboardTaskOccurrence = {
  readonly workboard_task_id?: number;
  readonly occurrence_id?: number | null;
  /**
   * Scheduled calendar date for this recurring task instance. To move the instance, keep this value and set rescheduled_to.
   */
  occurrence_date: string;
  status?: WorkboardTaskOccurrence.status;
  /**
   * Display date when this occurrence is moved off its scheduled date. Null clears a prior reschedule. occurrence_date remains the series instance identity.
   */
  rescheduled_to?: string | null;
};
export namespace WorkboardTaskOccurrence {
  export enum status {
    PENDING = 'pending',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
  }
}

